import { render } from "./PageNotFound.vue?vue&type=template&id=1eb340d0&scoped=true&ts=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"

import "./PageNotFound.vue?vue&type=style&index=0&id=1eb340d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb340d0"]])

export default __exports__